export default __webpack_public_path__ + "wix.841b0977.png";